/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Group_Type_TranscriptionInputs */



/**
* | output |
* | --- |
* | "Transcription" |
*
* @param {Merge_Event_Group_Group_Type_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_group_type_transcription = /** @type {((inputs?: Merge_Event_Group_Group_Type_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Group_Type_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Транскрипция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलिपि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição")
	return /** @type {LocalizedString} */ ("Transcription")
});